var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRightUp = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.87184 6.86667C6.87184 6.31438 7.31955 5.86667 7.87184 5.86667L17.1333 5.86667C17.6856 5.86667 18.1333 6.31438 18.1333 6.86667V16.1281C18.1333 16.6804 17.6856 17.1281 17.1333 17.1281C16.581 17.1281 16.1333 16.6804 16.1333 16.1281V9.28088L7.57375 17.8404C7.18322 18.231 6.55006 18.231 6.15953 17.8404C5.76901 17.4499 5.76901 16.8168 6.15953 16.4262L14.7191 7.86667L7.87184 7.86667C7.31955 7.86667 6.87184 7.41895 6.87184 6.86667Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowRightUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ArrowRightUp.ee3e1af954aa597106edd9b45eba8eef.svg";